export var API_SVC_BASE_URL = process.env.REACT_APP_API_SVC_BASE_URL;
export var LOCAL_SHOP_NAV = process.env.REACT_APP_LOCAL_SHOP_NAV;
export var ORIGIN = process.env.REACT_APP_ORIGIN;
export var FRONT_END_VERSION = (function () {
    var vers = process.env.REACT_APP_FRONT_END_VERSION;
    if (vers === undefined) {
        console.log('No version set');
        return Number.MAX_SAFE_INTEGER;
    }
    var versNum = parseInt(vers, 10);
    if (isNaN(versNum)) {
        console.log("Could not parse version " + vers);
        return Number.MAX_SAFE_INTEGER;
    }
    return versNum;
})();
export var GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '';
export var GOOGLE_ANALYTICS4_ID = process.env.REACT_APP_GOOGLE_ANALYTICS4_ID || '';
//# sourceMappingURL=Config.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/Config.js
// module id = 24
// module chunks = 0